// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos do Modal de Nova Versão do Projeto - Compatível com Modal de Prévias */

.styles_title__5AzpO {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.styles_content__wvfyA {
  align-items: center !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 1rem !important;
  padding-top: 1rem !important;
}

.styles_containerBtn__52NDf {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
}

.styles_btnCancelar__C9L2M {
  background: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
}

.styles_btnSalvar__tW4Pz {
  background: #18316e !important;
  border: 1px solid #18316e !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Projeto/ModalNovaVersaoProjeto/styles.module.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":["/* Estilos do Modal de Nova Versão do Projeto - Compatível com Modal de Prévias */\n\n.title {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.content {\n  align-items: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 1rem !important;\n  padding-top: 1rem !important;\n}\n\n.containerBtn {\n  display: flex !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n}\n\n.btnCancelar {\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n}\n\n.btnSalvar {\n  background: #18316e !important;\n  border: 1px solid #18316e !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__5AzpO`,
	"content": `styles_content__wvfyA`,
	"containerBtn": `styles_containerBtn__52NDf`,
	"btnCancelar": `styles_btnCancelar__C9L2M`,
	"btnSalvar": `styles_btnSalvar__tW4Pz`
};
export default ___CSS_LOADER_EXPORT___;
